<template>
  <v-container>
    <v-row>
      <v-col sm="12" md="6" lg="5">

        <FormActionButtons
          :buttons="[]" 
          :customButton="{
            text: false,
            color: '',
            label: 'Back to all supports' ,
            icon: 'mdi-chevron-left',
            icon_start: true
          }"
          noPadding
          @custom="returnToCategory"
        />
        <div class="pb-10"></div>

        <label class="text-body-2 grey--text text--darken-1">Name</label>
        <p class="text-body-1">{{item.name}}</p>

        <label class="text-body-2 grey--text text--darken-1">Category</label>
        <p class="text-body-1">{{item.category}}</p>

        <label class="text-body-2 grey--text text--darken-1">Mapping</label>
        <p class="text-body-1">{{item.reporting_type_name||'-'}}</p>

        <label class="text-body-2 grey--text text--darken-1">Description</label>
        <p class="text-body-1">{{item.description || '-'}}</p>

        <FormActionButtons
          v-if="!item.disabled"
          :buttons="[
            'edit'
          ]"
          :customButton="{
            text: true,
            color: 'red darken-2',
            label: 'Disable'
          }"
          @edit="$emit('edit')"
          @custom="deleteSupport"
        />

        <FormActionButtons
          v-if="item.disabled"
          :buttons="[]" 
          :customButton="{
            text: false,
            color: 'warning',
            label: 'Restore',
            icon: 'mdi-pencil',
            icon_start: false
          }"
          @custom="restoreSupport"
        />

      </v-col>
    </v-row>

    <DeleteModal
      v-if="deleteModal"
      title="Disable Support"
      :text="`Are you sure you wish to disable the current support <b>${item.name}</b>?`"
      deleteButtonText="disable"
      :strongWarning="false"
      @confirm="deleteSupportConfirm"
      @cancel="deleteSupportCancel" 
    />
  </v-container>
</template>

<script>
import { Api } from '@/gateways/endpoints'
import FormActionButtons from '@/components/elements/FormActionButtons.vue'
import DeleteModal from '@/components/elements/DeleteModal.vue'

export default {
  components: {
    FormActionButtons,
    DeleteModal
  },
  props: {
    item: {
      required: true,
    }
  },
  data () {
    return {
      deleteModal: false,
    }
  },

  async created () {
  },

  methods: {
    returnToCategory() {
      this.$router.push({name:'MappingCategoryPage',params:{category:'supports'}})
    },
    async restoreSupport () {
      this.loading = true
      const response = await Api.Supports.restore(this.item.support_id, this.item)
      if (response) {
        this.loading = false
        this.$toast.success('The support was successfully restored.')
        this.$router.push({name:'MappingCategoryPage',params:{category:'supports'}})
        return
      }
      this.loading = false
      this.$toast.error('Something went wrong. Please try again.')
    },
    deleteSupport () {
      this.deleteModal = true
    },
    async deleteSupportConfirm(){
      if (this.item.reporting_type===null) {
        this.deleteModal = false
        this.$toast.error('The support is missing a mapping.')
        return
      }
      this.deleteModal = false
      this.loading = true
      const response = await Api.Supports.delete(this.item.support_id, this.item)
      if (response) {
        this.loading = false
        this.$toast.success('The support was successfully disabled.')
        this.$router.push({name:'MappingCategoryPage',params:{category:'supports'}})
        return
      }
      this.loading = false
      this.$toast.error('Something went wrong. Please try again.')
    },
    deleteSupportCancel(){
      this.deleteModal = false
    }
  },

  computed: {
  }
}
</script>

<style lang="scss">
</style>
